export default {
  0: "内部および外部の両方の ID 管理プラットフォームを備えた当社は、お客様のビジネスに最適な製品と価格を提供することができます。",
  1: "カスタマーサービス時間：営業日9:00～19:00",
  2: "カスタマーサービス時間：7*24時間",
  3: "Authing SMS サービスには、登録、ログイン、ログイン例外、パスワード忘れ、メッセージ変更、支払い確認、イベント確認などがある。 Authing には専用のサーバールームがあり、大容量・高同時実行に対応しており、最大で毎秒10万回の伝送量を実現している。 そして排他的な実質機械監視、実時間監視および自動切換えを持っている。",
  4: "1つのアカウントで2チャネルで運用している。 SMS の途切れない送信を保障する SMS チャネルの理性的な切換え",
  5: "3大キャリアと手を組む。 トライネットの SMS チャンネルの使用。 仮想キャリアナンバリングにも対応",
  6: "企業の実名の排他的な SMS インターフェイス、800 のメッセージ/秒までの速度を送る。",
  7: "99.99% SMS CAPTCHA 到着率",
  8: "価格表の詳しい情報？",
  9: "お客様の連絡先情報をご記入ください。",
  10: "質問がある場合は、コメントで簡単に対処してください。",
  11: "統合認証プラットフォーム、統合ログイン、シングルサインオンの価格 - Identity Cloud とは？",
  用户身份管理: "ユーザー ID 管理",
  免费服务: "無料サービス：",
  免费8000次认证次数: "無料で8000回の認証",
  统一认证云: "統一認証クラウド",
  用户管理: "ユーザー管理",
  多因素认证: "多要素認証",
  集成主流登录方式: "統合された主流のログイン",
  在线技术文档: "オンライン技術文書",
  免费使用: "無料アクセス",
  增值服务: "付加価値サービス：",
  定制开发私有部署: "カスタム開発＆プライベート展開",
  更高级别安全管理: "高いレベルのセキュリティ管理",
  开发技术支持: "開発技術サポート",
  个性化产品培训: "パーソナル化された製品トレーニング",
  咨询顾问: "コンサルタント",
  员工身份管理: "従業員の ID 管理",
  免费10人团队: "フリー10人のチーム",
  单点登录: "シングルサインオン录",
  统一认证源: "統一認証ソース",
  集中授权: "権限管理",
  应用管理: "App 管理",
  日志审计: "ログ監査",
  企业咨询: "企業コンサルティング",
  Authing短信服务的优势: "Authing SMS のメリット：",
  多通道备份: "マルチ チャンネル バックアップ",
  三网合一: "トライネットワークの組み合わせ",
  独立端口: "セパレート ポート",
  到达率: "到着率",
  Authing短信包套餐: "Authing SMS パッケージ",
  条: "通",
  平均每条短信01元: "メッセージ1通あたり平均 0.1 元 （約1.5円）",
  平均每条短信005元: "メッセージ1通あたり平均 0.05 元 （約0.76円）",
  价格咨询请联系我们: "価格についてはお問い合わせください。",
  联系销售: "営業担当者への連絡",
  称呼: "宛名",
  我们的顾问将在三日内致电你: "3日以内にコンサルタントがご連絡させていただきます。",
  手机号: "携帯電話番号",
  公司名: "会社名",
  备注信息: "付記",
  提交: "提出",
  请输入你的姓名: "お名前を入力してください",
  请输入你的手机号: "携帯電話番号を入力してください",
  请输入合法的手机号: "有効な携帯電話番号を入力してください。",
  请输入你的公司名: "会社名を入力してください。",
  提交成功: "提出に成功した",
};
